import { Field, ErrorMessage } from 'formik';

export default function VehicleStep({ formTitle, finalEnhancementOptions }) {
  return (
    <div>
      <h2 className="mb-4 text-xl font-medium text-gray-700">
        Vehicle Information &amp; Enhancements
      </h2>
      <div>
        <label
          htmlFor="auto_year"
          className="block text-sm font-medium text-gray-700"
        >
          Year<span className="text-red-500">*</span>
        </label>
        <Field
          type="text"
          id="auto_year"
          name="auto_year"
          placeholder="2025"
          className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
        />
        <ErrorMessage
          name="auto_year"
          component="div"
          className="mt-1 text-xs text-red-500"
        />
      </div>
      <div className="mt-4">
        <label
          htmlFor="auto_make"
          className="block text-sm font-medium text-gray-700"
        >
          Make<span className="text-red-500">*</span>
        </label>
        <Field
          type="text"
          id="auto_make"
          name="auto_make"
          placeholder="Toyota"
          className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
        />
        <ErrorMessage
          name="auto_make"
          component="div"
          className="mt-1 text-xs text-red-500"
        />
      </div>
      <div className="mt-4">
        <label
          htmlFor="auto_model"
          className="block text-sm font-medium text-gray-700"
        >
          Model<span className="text-red-500">*</span>
        </label>
        <Field
          type="text"
          id="auto_model"
          name="auto_model"
          placeholder="Camry"
          className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
        />
        <ErrorMessage
          name="auto_model"
          component="div"
          className="mt-1 text-xs text-red-500"
        />
      </div>
      <div className="mt-4">
        <label
          htmlFor="trim"
          className="block text-sm font-medium text-gray-700"
        >
          Trim (Optional)
        </label>
        <Field
          type="text"
          id="trim"
          name="trim"
          placeholder="e.g., SE"
          className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
        />
        <ErrorMessage
          name="trim"
          component="div"
          className="mt-1 text-xs text-red-500"
        />
      </div>
      <div className="mt-6">
        <label className="block text-sm font-medium text-gray-700">
          {formTitle} Estimate Enhancements (Optional)
          <p className="text-xs italic">**Select any that apply</p>
        </label>
        <div className="mt-1 space-y-2">
          {finalEnhancementOptions.map((option, i) => (
            <div key={i} className="flex items-center">
              <Field
                type="checkbox"
                name="enhancements"
                value={option}
                className="rounded border-gray-300 text-blue-600"
              />
              <label htmlFor={option} className="ml-2 text-sm text-gray-700">
                {option}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
